import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";

@forbidExtraArgs
export default class LoadBalancerListener extends Component {
  @service abilities;

  @arg listener;
  @arg certificates;

  get certificateItems() {
    let certificates = this.certificates?.slice().map((certificate) => ({
      value: certificate.id,
      label: certificate.id,
    }));
    return [{ label: "-", value: "none" }].concat(certificates ?? []);
  }

  get selectedCertificate() {
    if (this.listener.sslcertificate === "none") {
      return "none";
    }
    return this.listener.sslcertificate || "none";
  }

  get certificateIsDisabled() {
    return (
      this.listener.isDeleted ||
      this.listener.mode === "tcp" ||
      this.abilities.cannot("edit load-balancer", this.loadBalancer)
    );
  }

  modeSelections = Object.freeze([{ value: "http" }, { value: "tcp" }]);

  get loadBalancer() {
    return this.listener.loadBalancer;
  }

  sessionOptions = Object.freeze([{ value: "yes" }, { value: "no" }]);

  get sessionSelection() {
    return this.listener.stickysessions ? "yes" : "no";
  }

  portSelected = (event) => (this.listener.port = parseInt(event.target.value));

  modeSelected = (event) => {
    let mode = event.target.value;

    if (mode === "tcp" && this.listener.sslcertificate) {
      this.listener.sslcertificate = "none";
    }

    this.listener.mode = mode;
  };

  @action
  certificateSelected(event) {
    this.listener.sslcertificate = event.target.value;
  }

  @action
  stickySessionChange(event) {
    this.listener.stickysessions = event.target.value === "yes";
  }

  @action
  deletePort() {
    let listener = this.listener;

    if (listener.get("isDeleted")) {
      listener.rollbackAttributes();
    } else {
      listener.deleteRecord();
    }
  }
}
